import React from 'react';

import { t, jt } from 'ttag';
import { connect } from 'react-redux';

import Price from '../../../utils/prices';

import './priceStyle.less';

function ProductPrice({ isSoldOut, prices, selections, sizes }) {
  if (
    (!isSoldOut && (prices.min_price || prices.max_price)) ||
    (selections.sizeDetails &&
      selections.sizeDetails.prices &&
      selections.sizeDetails.prices.price &&
      sizes.length)
  ) {
    const selected_prices = selections.sizeDetails
      ? selections.sizeDetails.prices
      : prices;
    const {
      price,
      min_price,
      max_price,
      vat_rate,
      discount_percentage,
      currency
    } = selected_prices;
    const discounted = discount_percentage > 0;
    const sale_price = new Price(min_price || max_price || price, currency);
    const rrp = new Price(prices.recommended_retail_price, currency);

    return (
      <div id="productPrice" className="flex flex-col">
        <div>
          <span
            className={`fullPrice ${discounted ? ' discounted' : ''}`}
            data-testid="price"
          >
            {min_price !== max_price ? `${t`From`} ` : ''}
            {sale_price.toString()}
          </span>

          {discounted && <span className="oldPrice">{rrp.toString()}</span>}
        </div>
        {vat_rate && (
          <span className="VAT">{jt`Price is incl. ${vat_rate}% VAT`}</span>
        )}
      </div>
    );
  }
  return null;
}

const mapStateToProps = ({ app }) => {
  return {
    isSoldOut: app.data.is_sold_out,
    prices: app.data.prices,
    selections: app.selections,
    sizes: app.data.sizes
  };
};

export default connect(mapStateToProps)(ProductPrice);
